import React from "react";
import { Pagination } from "antd";

const PaginationComponent = ({ currentPage, pageSize, total, onChange }) => {
  return (
    <Pagination
      current={currentPage}
      pageSize={pageSize}
      total={total}
      onChange={onChange}
      showSizeChanger={false}
    />
  );
};

export default PaginationComponent;
